import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { environment } from '@env/environment';

@Injectable()
export class FileService {
  constructor(private http: HttpClient) {}

  sendFile(formData: any) {
    //  const baseUrl = appConfig.apiUrl;
    const url = '/cargar';
    return this.http
      .post(url, formData, {
        reportProgress: true,
        observe: 'events'
      })
      .pipe();
  }

  errorMgmt(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(errorMessage);
  }
}
